import axios from "axios";

const API_URL = "https://movies-api.accel.li/api/v2";

export function getMoviesByName(
  query,
  quality,
  genre,
  rating,
  year,
  sort_by,
  order,
  page
) {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${API_URL}/list_movies.json?query_term=${query}&quality=${quality}&genre=${genre}&minimum_rating=${rating}&${year}&sort_by=${sort_by}&order_by=${order}&page=${page}&limit=50`
      )
      .then((res) => {
        resolve(res?.data?.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function getMovieDetailById(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/movie_details.json?movie_id=${id}`)
      .then((res) => {
        resolve(res?.data?.data);
        // console.log(res?.data?.data)
      })
      .catch((err) => {
        reject(err);
      });
  });
}
